module.exports = __webpack_public_path__ + "static/img/zhangdan.1e36785d.png";